import { clickOutside } from '@/shared/helpers/helpers';

const headerSearchSelector = '.js-header-search';
const headerSearchResultsSelector = '.js-header-search-demo-results';

class HeaderSearch {
	constructor(searchBox) {
		this.searchBox = searchBox;
		this.searchButton = this.searchBox.querySelector('.js-header-search-button');
		this.searchInput = this.searchBox.querySelector('.js-header-search-input');
		this.searchResults = this.searchBox.querySelector(headerSearchResultsSelector);
		this.searchHistory = this.searchResults?.querySelector('.js-header-search-history');
		this.activeSearchHistory = this.searchHistory;
		this.clearSearchHistory = this.searchResults?.querySelector('.js-header-search-clear');
		this.removeItemButtons = this.searchResults?.querySelectorAll('.js-header-search-remove');
		this.laptopMQ = window.matchMedia(`(min-width: ${window.vars.breakpoint.laptop}px)`);
		this.activeMobileSearch = this.searchBox.classList.contains('is-active');

		this.bindEvents();
	}

	onSearchButtonClick = (e) => {
		if (this.laptopMQ.matches || this.activeMobileSearch) return;
		e.preventDefault();
		this.searchBox.classList.add('is-active');
		this.searchInput.focus();
	};

	onSearchInput = () => {
		if (!this.searchHistory) return;
		this.activeSearchHistory && this.searchHistory.classList.remove('is-visible');
		if (this.searchInput.value.length > 0) {
			this.searchResults.classList.add('is-active');
		} else {
			this.searchResults.classList.remove('is-active');
		}
	};

	onSearchFocus = () => {
		if (!this.searchHistory) return;
		if (this.activeSearchHistory && this.searchInput.value.length === 0) {
			this.searchResults.classList.add('is-active');
			this.searchHistory.classList.add('is-visible');
		}
		if (this.searchInput.value.length > 0) {
			this.searchResults.classList.add('is-active');
		}
		if (this.laptopMQ.matches) {
			window.addEventListener('resize', this.closeResults, { once: true });
		} else {
			this.laptopMQ.addEventListener('change', this.closeResults, { once: true });
		}
	};

	removeHistoryItem = (e) => {
		e.stopPropagation();
		const item = e.target.closest('.search-history__item');
		if (item.parentNode.children.length === 1) {
			item.remove();
			this.clearHistory();
		} else {
			item.remove();
		}
	};

	clearHistory = () => {
		this.searchHistory.remove();
		this.activeSearchHistory = false;
		this.closeResults();
	};

	closeResults = () => {
		this.searchResults.classList.remove('is-active');
		this.laptopMQ.matches && this.searchBox.classList.remove('is-active');
	};

	bindEvents() {
		this.searchButton.addEventListener('click', this.onSearchButtonClick);
		this.searchInput.addEventListener('input', this.onSearchInput);
		this.searchInput.addEventListener('focus', this.onSearchFocus);
		window.addEventListener('click', (e) => {
			const activeResults = this.searchResults?.classList.contains('is-active');
			if (activeResults && clickOutside(e, this.searchBox)) {
				this.searchResults.classList.remove('is-active');
			}

			if (!this.laptopMQ.matches && clickOutside(e, this.searchBox)) {
				this.searchBox.classList.remove('is-active');
				activeResults && this.searchResults.classList.remove('is-active');
			}
		});

		this.clearSearchHistory?.addEventListener('click', this.clearHistory);
		this.removeItemButtons?.forEach((button) => {
			button.addEventListener('click', (e) => this.removeHistoryItem(e));
		});
	}
}

export default class InitHeaderSearch {
	constructor() {
		this.init();
	}

	init() {
		const headerSearch = document.querySelector(headerSearchSelector);
		headerSearch && new HeaderSearch(headerSearch);
	}
}
